const sortTrends = (trends: any[]): any[] => {
  const sortedTrends = trends.map((metric: any) => {
    metric.data = metric.data
      .map((slot: any) => ({ ...slot, date: new Date(slot.periodKey) }))
      .sort((a: any, b: any) => (a.periodKey < b.periodKey ? 1 : -1));
    return Object.assign(metric, {
      breakdown: metric?.breakdown
        ? `${metric?.breakdown.split(/(?=[A-Z])/).join(' ')} ${
            metric?.data[0]?.contentType
          }`
        : metric?.data[0]?.contentType,
    });
  });
  if (trends[0]?.breakdown) {
    sortedTrends.sort((a, b) => a.breakdownCustomerId - b.breakdownCustomerId);
  }
  return sortedTrends;
};

export default sortTrends;
